module.exports = __webpack_public_path__ + "img/mourlan.5c0c3078.jpg";